import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { formatResourcePath } from 'src/utils/regex';

import type { SubParking } from 'src/features/parkingManagement/types/parking';
import type { MutationConfig } from 'src/lib/react-query';
import type { GeneralSmartParkError } from 'src/types/errors';

interface DTO {
    parkingId: string;
    id: string;
}

const RESOURCE = '/parkings/:parkingId/sub-parkings/:id/';

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, id, ...data }: DTO): Promise<SubParking> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, id }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateSubParking };
